import { IIdAndName } from '@cinetixx/cinetixx-ui';
import { PriorityShapes } from '../enums/PriorityShapes';
import { IBaseElement, IImageElement, IPriorityShape, ISeat, ISectorElement, IShape } from '../interfaces';

import { InjectionToken } from '@angular/core';

export const ORDER_OF_ROWS = new InjectionToken<Array<{ id: number; name: string; default?: boolean }>>('Order of Rows');
export const ORDER_OF_SEATS = new InjectionToken<Array<{ id: number; name: string; default?: boolean }>>('Order of Seats');
export const SHAPE_SEAT_TYPES = new InjectionToken<Array<{ id: string; name: string }>>('Shape Seat Types');
export const MIXED_NAME = new InjectionToken<string>('Mixed Name');

export const SEAT_TYPE_DISABLED_ID = 4045359;
export const SEAT_TYPE_WHEELCHAIR_ID = 2277;
export const SEAT_TYPE_SEAT_ID = 2275;
export const DEFAULT_SEAT_COLOR = '#A5D4FA';
export const BLOCKED_SEAT_COLOR = '#B1B2B2';
export const DEFAULT_SCREEN_COLOR = '#4788C7';

export const DEFAULT_PRIORITY_SHAPE_DATA: IPriorityShape = {
  x: 0,
  y: 0,
  w: 80,
  h: 80,
  shapeType: PriorityShapes.CIRCLE,
  shape: null,
  rotate: 0
};

export const DEFAULT_SEAT_DATA: ISeat = {
  /**
   * Seat ID
   */
  id: null,
  /**
   * Show on hover on shape
   */
  loveSeatId: null,
  seatTypeId: null,
  termId: null,
  /**
   * Row number default (0)
   */
  rank: 0,
  /**
   * Row number default (0)
   */
  rankToken: '0',
  /**
   * Seat number default (0)
   */
  seatNumber: 0,
  /**
   * Seat count (default 1, always 1)
   */
  seatCount: 1,
  /**
   * Status id from dictionary
   */
  seatStatusId: 30785,
  /**
   * Id from left seat definition if exists
   */
  leftSeatDefinitionId: null,
  /**
   * Id from right seat definition if exists
   */
  rightSeatDefinitionId: null,
  /**
   * Zone ID
   */
  areaId: null,
  priceAreaColor: null,
  ticketEntryText: null,
  name: null,
  seatWeight: 0,
  sectorElement: {
    /**
     * x position in web manager
     */
    webX: 0,
    /**
     * y position in web manager
     */
    webY: 0,
    x: 0,
    y: 0,
    w: 0,
    h: 0,
    color: '',
    shapeId: null,
    rotate: 0,
    /**
     * Automatic seat number (default TRUE)
     */
    flagSeatFac: true,
    /**
     * Automatic row number (default TRUE)
     */
    flagRankFac: true,
    /**
     * Content displayed on the seat (default should show nothing)
     */
    title: '',
    /**
     * Minimum font size for the title (default 0 for seats)
     */
    titleSizeMin: 0,
    /**
     * Maximum font size for the title (default 2 for seats)
     */
    titleSizeMax: 2,
    /**
     * Copied from shape
     */
    imageY: 0,
    /**
     * Copied from shape
     */
    imageX: 0,
    /**
     * Copied from shape
     */
    image: 0,
    /**
     * Id of the align curve
     */
    alignCurveId: null,
    /**
     * Position of the seat in the curve (default 0) numbers means 7500 means el is placed in 75% of the curve etc.
     */
    alignCurvePosition: 0,
    /**
     * Id of the seat configuration (default -> id from sector)
     */
    seatConfigurationId: null,
    /**
     * Id of sector element?
     */
    id: null,
    /**
     * Show in element settings title field
     */
    ruleTitle: '@p',
    /**
     * Show in element settings infoText1 field
     */
    ruleTopText: '',
    /**
     * Show in element settings infoText2 field
     */
    ruleBottomText: '',
    /**
     * Show in element settings tipText field
     */
    ruleTipText: '@r\n' + 'Platz @p',
    /**
     * Show inside shape as info text 1
     */
    topText: '',
    /**
     * Show inside shape as info text 2
     */
    bottomText: '',
    /**
     * Show on hover on shape
     */
    tipText: '',
    sectorId: null,
  }
};

export const DEFAULT_SECTOR_DIMENSIONS = {
  w: 220,
  h: 70
};

export const DEFAULT_BASE_ELEMENT_DATA: IBaseElement = {
  /**
   * x position in web manager
   */
  webX: 0,
  /**
   * y position in web manager
   */
  webY: 0,
  x: 0,
  y: 0,
  w: 0,
  h: 0,
  color: '',
  shapeId: null,
  rotate: 0,
  /**
   * Automatic seat number (default FALSE for base elements)
   */
  flagSeatFac: false,
  /**
   * Automatic row number (default FALSE for base elements)
   */
  flagRankFac: false,
  /**
   * Content displayed on the seat (default should show seat number)
   */
  title: '',
  /**
   * Minimum font size for the title (default 0 for base elements)
   */
  titleSizeMin: 0,
  /**
   * Maximum font size for the title (default 0 fir base elements)
   */
  titleSizeMax: 0,
  /**
   * Copied from shape
   */
  image: 0,
  /**
   * Copied from shape
   */
  imageY: 0,
  /**
   * Copied from shape
   */
  imageX: 0,
  /**
   * Id of the align curve, assign by BE
   */
  alignCurveId: null,
  /**
   * Position of the seat in the curve (default 0) numbers means 7500 means el is placed in 75% of the curve etc.
   */
  alignCurvePosition: 0,
  /**
   * Id of the seat configuration (default -> id from sector)
   */
  seatConfigurationId: null,
  /**
   * Id of sector element?
   */
  id: null,
  /**
   * Show in element settings title field
   */
  ruleTitle: '',
  /**
   * Show in element settings infoText1 field
   */
  ruleTopText: '',
  /**
   * Show in element settings infoText2 field
   */
  ruleBottomText: '',
  /**
   * Show in element settings tipText field
   */
  ruleTipText: '',
  /**
   * Show inside shape as info text 1
   */
  topText: '',
  /**
   * Show inside shape as info text 2
   */
  bottomText: '',
  /**
   * Show on hover on shape
   */
  tipText: '',
  sectorId: null,
};

export const DEFAULT_SECTOR_ELEMENT_DATA: ISectorElement = {
  id: null,
  sectorId: null,
  /**
   * X position of element, x only has a value if its view from sectors plan,
   */
  x: 0,
  /**
   * Y position of element, y only has a value if its view from sectors plan
   */
  y: 0,
  /**
  * x position in web manager
  */
  webX: 0,
  /**
   * y position in web manager
  */
  webY: 0,
  /**
   * width of element
   */
  w: 0,
  /**
   * height of element
   */
  h: 0,
  /**
   * Color of element
   */
  color: '',
  /**
   * Automatic seat number (default TRUE)
   */
  flagSeatFac: true,
  /**
   * Automatic row number (default TRUE)
   */
  flagRankFac: true,
  title: '',
  ruleTitle: '',
  titleSizeMin: 0,
  titleSizeMax: 0,
  topText: '',
  ruleTopText: '',
  bottomText: '',
  ruleBottomText: '',
  tipText: '',
  ruleTipText: '',
  image: 0,
  imageX: 0,
  imageY: 0,
  shapeId: null,
  rotate: 0,
  alignCurveId: null,
  alignCurvePosition: 0,
  seatConfigurationId: null,
};

export const MIN_SECTOR_DIMENSIONS = {
  w: 480,
  h: 500
};

export const DEFAULT_SHAPE_DATA: IShape = {
  id: null,
  name: '',
  shapeType: null,
  loveSeatId: null,
  position: 0,
  image: 0,
  imageX: 0,
  imageY: 0,
  color: DEFAULT_SEAT_COLOR,
  shapeSeatType: null,
  polygonPoints: [],
  rectPoints: [],
  default: false,
  flagDefaultShape: false
};

export const DEFAULT_IMAGE_DATA: IImageElement = {
  id: null,
  imageId: null,
  x: 0,
  y: 0,
  w: 30,
  h: 30,
  layer: 0,
  lock: false
};

export const DEFAULT_IMAGE_LAYER = 1000;

export const LINES: IIdAndName<number>[] = [
  {id: 0, name: '0'},
  {id: 1, name: '1'},
  {id: 2, name: '2'},
  {id: 3, name: '3'},
  {id: 4, name: '4'},
  {id: 5, name: '5'}
];
export const COLUMNS: IIdAndName<number>[] = [
  {id: 0, name: '0'},
  {id: 1, name: '1'},
  {id: 2, name: '2'},
  {id: 3, name: '3'},
  {id: 4, name: '4'},
  {id: 5, name: '5'},
  {id: 6, name: '6'},
  {id: 7, name: '7'}
];
